import React from 'react'

const GoalStatusIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40H9C4.02944 40 0 35.9706 0 31V9Z"
        fill={color}
      />
      <g clipPath="url(#clip0_4200_42046)">
        <path
          d="M20 11L22.7823 16.9261L29 17.875L24.5 22.4872L25.562 29L20 25.9234L14.438 29L15.5 22.4872L11 17.875L17.2177 16.9261L20 11Z"
          fill="white"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4200_42046">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GoalStatusIcon
